import { useEffect } from 'react';
import axios from 'axios';
import { Authentication } from './auth.utils';

const apiUrl = process.env.REACT_APP_API_URL;
const REFRESH_INTERVAL_MS = 5 * 60 * 1000; // Refresh every 5 minutes

export const useTokenRefresh = () => {
  useEffect(() => {
    const auth = new Authentication();

    // Only set up refresh if user is authenticated
    if (!auth.isAuthenticated()) {
      return;
    }

    const refreshTokenPeriodically = async () => {
      try {
        const refreshToken = localStorage.getItem('refreshToken');
        if (!refreshToken) {
          console.warn('No refresh token found');
          return;
        }

        console.log('🔄 Refreshing token periodically...');
        const response = await axios.post(
          `${apiUrl}api/v1/ekutir/user/auth/refreshToken`,
          { refreshToken }
        );

        const { accessToken, refreshToken: newRefreshToken, user } = response.data;
        if (accessToken && newRefreshToken) {
          localStorage.setItem('accessToken', accessToken);
          localStorage.setItem('refreshToken', newRefreshToken);
          if (user) {
            localStorage.setItem('userData', JSON.stringify(user));
          }
          console.log('✅ Token refreshed successfully');
        }
      } catch (error) {
        console.error('❌ Periodic token refresh failed:', error.response?.status);
        // Don't handle session expiry here - let axios interceptor handle it
      }
    };

    // Start the interval
    const intervalId = setInterval(refreshTokenPeriodically, REFRESH_INTERVAL_MS);

    // Clean up interval on unmount
    return () => clearInterval(intervalId);
  }, []);
};
